export const isMouseInTopArea = (clientX: number, clientY: number) => {
  const topAreaHeight = 21;
  return (
    clientX >= 0 &&
    clientX <= window.innerWidth &&
    clientY >= 0 &&
    clientY < topAreaHeight
  );
};
